<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="详情"
    @cancel="cancel"
    :bodyStyle="{ paddingBottom: '80px' }"
  >
    <a-descriptions title="任务要求" :column="2" bordered>
      <a-descriptions-item label="任务名称">
        {{ modal.workerName }}
      </a-descriptions-item>
      <a-descriptions-item label="任务描述">
        <span v-html="modal.content"></span>
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ modal.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="截止时间">
        {{ modal.endTime }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="文件下载"
      :column="3"
      bordered
      style="margin-top:16px"
    >
      <a-descriptions-item label="文件列表">
        <div class="fileItem" v-for="item in modal.attachments" :key="item.id">
          <img
            v-if="item.fileType == 'jpg' || item.fileType == 'png'"
            :src="item.filePath"
            width="30"
            height="30"
          />
          <img
            v-else-if="item.fileType == 'ppt'"
            src="@/assets/imgs/resource/btn_ppt.png"
            width="30"
            height="30"
          />
          <img
            v-else-if="item.fileType == 'pdf'"
            src="@/assets/imgs/resource/btn_pdf.png"
            width="30"
            height="30"
          />
          <img
            v-else-if="item.fileType == 'docx' || item.fileType == 'doc'"
            src="@/assets/imgs/resource/btn_word.png"
            width="30"
            height="30"
          />
          <a :href="item.filePath">{{ item.fileName }}</a>
        </div>
      </a-descriptions-item>
    </a-descriptions>

    <div
      slot="footer"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1
      }"
    >
      <a-button
        :style="{ marginRight: '.8rem' }"
        @click="refuse"
        :loading="refuseLoading"
      >
        拒绝
      </a-button>
      <a-button type="primary" @click="agree" :loading="agreeLoading">
        通过
      </a-button>
    </div>
    <edit ref="edit" @ok="submit" />
  </a-modal>
</template>
<script>
import edit from "./modules/edit";
import moment from "moment";

export default {
  components: {
    edit
  },
  data() {
    return {
      //modal
      visible: false,
      modal: {},
      //btn
      agreeLoading: false,
      refuseLoading: false
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      if (record) {
        this.modal = record;

        this.modal.startTime = moment(this.modal.startTime).format(
          "YYYY-MM-DD"
        );
        this.modal.endTime = moment(this.modal.endTime).format("YYYY-MM-DD");
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    },
    //通过
    agree() {
      this.agreeLoading = true;
      this.modal.code = "A";
      this.$refs.edit.show(this.modal);
      setTimeout(() => {
        this.agreeLoading = false;
      }, 3000);
    },
    //拒绝
    refuse() {
      this.refuseLoading = true;
      this.modal.code = "R";
      this.$refs.edit.show(this.modal);
      setTimeout(() => {
        this.refuseLoading = false;
      }, 3000);
    },
    submit() {
      this.$emit("ok");
      this.cancel();
    }
  }
};
</script>
<style lang="less" scoped>
.fileItem {
  margin: 6px 0;
}
</style>
